module.exports = __webpack_public_path__ + "img/9.c3ffa4a3.jpeg";